import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { initTheme } from './utils/theme';
import { initProjectTheme } from './utils/projectTheme';
import { initAppInsights } from './utils/appInsights';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { setAdminMsalInstance } from './utils/axiosAdminApiInstance';
import { runRedirectBridge } from './utils/redirectBridge';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (window.location.pathname === '/redirect') {
  // Relay the auth response from the popup back to the opener via BroadcastChannel.
  // MSAL must NOT be initialized here — it would consume the response before it can be relayed.
  runRedirectBridge();
  root.render(<div />);
} else {
  initTheme();
  initAppInsights();
  initProjectTheme();

  const msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.initialize().then(() => {
    setAdminMsalInstance(msalInstance);
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
}

reportWebVitals();
